import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Divider, Notification, StackView, Typography, Box } from '@telus-uds/components-web';
import SectionHeading from '../sectionHeading';
import ReactHtmlParser from 'react-html-parser';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { getUpdatedAccessoriesList } from './util';

import Table from './components/table';

const Hardware = ({
  productSelected,
  hardwareList = [],
  contentfulError,
  isRenewal,
  viewType,
  ratePlans,
  hardware,
  setHardware,
  total,
  setTotal,
  error,
  geoTabNewPriceValid
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: {
      hardwareHeading,
      hardwareNote1,
      hardwareNote2,
      hardwareNote3,
      hardwareNoteNss
    },
    USERS: {
      USER_AUTHENTICATION: {
        labels: { NOTE }
      }
    },
    contentfulValues: {
      valueGeotab,
      valueNorthStarSystems,
      valueNorthStarSystemsFarmAndRanch
    }
  } = localizedStrings;
  const hardwares = hardwareList.filter(
    item => !_.get(item, 'fields.isAccessory', false)
  );
  const [accessories, setAccessories] = useState([]);

  useEffect(() => {
    const Accessories = hardwareList.filter(item =>
      _.get(item, 'fields.isAccessory', false)
    );
    const updatedAccessories = getUpdatedAccessoriesList(Accessories)
    geoTabNewPriceValid ? setAccessories(updatedAccessories) : setAccessories(Accessories)

  }, [geoTabNewPriceValid])

  return (
    <>
      {contentfulError && (
        <Notification variant={{ validation: 'error' }}>
          Error fetching hardware data from contentful
        </Notification>
      )}

      {!contentfulError && hardwareList && hardwareList.length > 0 && (
        <>
          <StackView space={3}>
            <SectionHeading>
              <Typography heading="h4" variant={{ size: 'h4' }} block>
                {productSelected === valueNorthStarSystemsFarmAndRanch
                  ? 'Hardware'
                  : hardwareHeading}
              </Typography>
            </SectionHeading>
            {productSelected !== valueNorthStarSystemsFarmAndRanch && (
              <div
                style={{
                  padding: '1rem',
                  backgroundColor: '#f3f0ff',
                  borderRadius: '6px'
                }}
              >
                <StackView space={2}>
                  <Typography variant={{ size: 'body' }} block>
                    <strong>{NOTE}</strong>
                  </Typography>
                  <ul style={{ marginLeft: '1rem', listStyle: 'auto', marginTop: '0.5rem' }}>
                    {productSelected !== valueNorthStarSystems && (
                      <>
                        <li>{hardwareNote1}</li>
                        <li>{hardwareNote2}</li>
                      </>
                    )}
                    {productSelected === valueGeotab && (
                      <li>{ReactHtmlParser(hardwareNote3)}</li>
                    )}
                    {productSelected === valueNorthStarSystems && (
                      <li>{hardwareNoteNss}</li>
                    )}
                  </ul>
                </StackView>
              </div>
            )}

            {hardwares.length > 0 && (
              <Table
                type="HARDWARE"
                isRenewal={isRenewal}
                viewType={viewType}
                ratePlans={ratePlans}
                hardware={hardware}
                setHardware={setHardware}
                list={hardwares}
                total={total}
                setTotal={setTotal}
              />
            )}
            {accessories.length > 0 && (
              <Table
                type="ACCESSORY"
                isRenewal={isRenewal}
                viewType={viewType}
                ratePlans={ratePlans}
                hardware={hardware}
                setHardware={setHardware}
                list={accessories}
                total={total}
                setTotal={setTotal}
                geoTabNewPriceValid={geoTabNewPriceValid}
              />
            )}
            {error && (
              <Notification variant={{ validation: 'error' }}>
                {error}
              </Notification>
            )}
          </StackView>

          <Divider space={3} variant={{ inverse: true }} />
        </>
      )}
    </>
  );
};

Hardware.propTypes = {
  productSelected: PropTypes.string.isRequired,
  hardwareList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  contentfulError: PropTypes.shape({}).isRequired,
  isRenewal: PropTypes.bool.isRequired,
  viewType: PropTypes.string.isRequired,
  ratePlans: PropTypes.shape({}).isRequired,
  hardware: PropTypes.shape({}).isRequired,
  setHardware: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired
};

export default Hardware;
